import React from 'react';
import PageShell from './PageShell';
import { companyInfo, mountainsLayered } from '../mock';
import { Mail, MapPin, Phone, Printer } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

// Force LTR reading for contact details so numbers/addresses render identically
// across IT / EN / AR (left-aligned, left-to-right).
const LtrBlock = ({ children, className = '' }) => (
  <div dir="ltr" style={{ unicodeBidi: 'isolate', textAlign: 'left' }} className={className}>
    {children}
  </div>
);

const ContattiPage = () => {
  const { t } = useLang();

  const cards = [
    {
      icon: MapPin,
      title: t('contatti.legalOffice'),
      body: (
        <LtrBlock>
          <p>{companyInfo.legal}</p>
          <p className="mt-1">{companyInfo.legalAddress}</p>
        </LtrBlock>
      ),
    },
    {
      icon: MapPin,
      title: t('contatti.opOffice'),
      body: (
        <LtrBlock>
          <p>{companyInfo.opAddress}</p>
        </LtrBlock>
      ),
    },
    {
      icon: MapPin,
      title: companyInfo.ksaLabel,
      body: (
        <LtrBlock>
          <p className="whitespace-pre-line">{companyInfo.ksaAddress}</p>
          <p className="mt-3 flex items-center gap-2">
            <Phone size={14} className="text-[#c53114]" />
            <span>tel. {companyInfo.ksaPhone}</span>
          </p>
          <p className="mt-1 flex items-center gap-2">
            <Mail size={14} className="text-[#c53114]" />
            <a href={`mailto:${companyInfo.ksaEmail}`} className="hover:text-[#c53114] transition-colors">
              {companyInfo.ksaEmail}
            </a>
          </p>
        </LtrBlock>
      ),
    },
    {
      icon: Phone,
      title: t('contatti.phone'),
      body: (
        <LtrBlock>
          <p className="flex items-center gap-2">
            <Phone size={14} className="text-[#c53114]" />
            <span>tel. {companyInfo.tel1}</span>
          </p>
          <p className="mt-1 flex items-center gap-2">
            <Phone size={14} className="text-[#c53114]" />
            <span>tel. {companyInfo.tel2}</span>
          </p>
          <p className="mt-1 flex items-center gap-2">
            <Printer size={14} className="text-[#c53114]" />
            <span>fax {companyInfo.fax}</span>
          </p>
        </LtrBlock>
      ),
    },
  ];

  return (
    <PageShell eyebrow={t('contact.eyebrow')} title={t('contact.title')} image={mountainsLayered}>
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map((b) => {
            const Icon = b.icon;
            return (
              <div key={b.title} className="p-8 bg-[#f5f7fa] border-t-2 border-[#c53114]">
                <div className="w-12 h-12 rounded-full bg-[#0b2545] text-white flex items-center justify-center">
                  <Icon size={20} />
                </div>
                <h3 className="mt-5 text-xl font-semibold text-[#0b2545]">{b.title}</h3>
                <div className="mt-2 text-[#475569] leading-relaxed text-sm">{b.body}</div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 max-w-6xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row gap-6 items-start">
          <a
            href={`mailto:${companyInfo.email}`}
            dir="ltr"
            style={{ unicodeBidi: 'isolate' }}
            className="inline-flex items-center gap-3 text-[#0b2545] hover:text-[#c53114] transition-colors"
          >
            <Mail size={18} /> <span className="font-medium">{companyInfo.email}</span>
          </a>
        </div>
      </section>
    </PageShell>
  );
};

export default ContattiPage;
